module.exports = __webpack_public_path__ + "static/media/loan-or-credit-income.1f9d2318.svg";